// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-pane {
  position: absolute;
  left: 0;
  color: #fff;
  top: 82px;
  height: calc(100vh - 80px);
  box-shadow: 5px 0 5px rgba(0, 0, 0, 0.3);
  transition: transform 0.4s ease;
  z-index: 1000;
  font-family: 'Open Sans';
  display: block !important;
  background-color: #3D434F !important;
}
.menu-pane .vertical-menu.open {
  width: 320px;
}
.menu-pane .vertical-menu.closed {
  width: 88px;
}
.close-menu {
  float: right;
  margin-right: 10px;
}
.close-menu:hover,
.open-menu:hover {
  cursor: pointer;
}
.close-menu img:hover,
.open-menu img:hover {
  filter: brightness(1.4) contrast(0.8);
}
.menu-link-wrapper {
  padding-left: 20px;
}
.menu-link a {
  color: #66D1FF;
  font-size: 16px;
}
.menulink.active {
  background-color: #66D1FF26;
  border-radius: 4px;
}
.full-menu > .menu-link > a:hover {
  background-color: #66D1FF26;
  border-radius: 4px;
}
.menu-link {
  vertical-align: middle;
}
.menu-link a > span {
  float: right;
}
.menu-link a > span img {
  height: 18px;
  width: 18px;
}
.menu-link img {
  height: 22px;
  width: 22px;
  padding-right: 10px;
  vertical-align: middle;
}
.menu-link a:hover img {
  filter: brightness(1.2) contrast(1);
}
.sidebar img {
  padding: 0px;
}
.vertical-menu.open {
  margin-left: 20px;
}
.vertical-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.menu-divider {
  height: 1px;
  width: 300px;
  background-color: #4D556F;
  display: block;
}
.full-menu li {
  width: 300px;
  position: relative;
  border-radius: 4px;
}
.full-menu a {
  display: block;
  padding: 10px;
  text-decoration: none;
}
.vertical-menu h3 {
  color: #ccc;
}
.menu-opener {
  cursor: pointer;
}
.submenu {
  display: none;
}
.submenu.active {
  display: block;
}
.submenu li {
  width: 290px;
}
.submenu li a {
  margin-left: 20px;
  color: #66D1FF;
  font-size: 16px;
}
.submenu li:hover {
  background-color: #66D1FF26;
  border-radius: 4px;
}
.sidebar-wrapper {
  width: 100%;
  text-align: center;
  padding-top: 22px;
}
.sidebar-wrapper div:hover svg path {
  fill: #CAEEFF;
}
.sidebar li:hover {
  background-color: #66D1FF26;
  border-radius: 4px;
}
.sidebar li a {
  display: flex;
  height: 45px;
  width: 45px;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  margin: auto;
}
.sidebar li a img {
  height: 22px;
  width: 22px;
}
.sidebar-divider {
  height: 1px;
  width: 100%;
  background-color: #4D556F;
  display: block;
}
.highlighted {
  background-color: #66D1FF80;
}
.menu-footer {
  position: absolute;
  bottom: 0;
  width: 290px;
  text-align: center;
  border-radius: 0 0 5px 5px;
}
/* Sidebar Submenu */
.sbsubmenu {
  display: none;
  width: 200px;
  white-space: nowrap;
  position: absolute;
  background-color: #3D434F;
  border-radius: 5px;
  z-index: 1001;
}
.sidebar .menu-link:hover .sbsubmenu,
.vertical-menu.open .menu-link:hover .sbsubmenu {
  display: block;
}
.vertical-menu.open .sbsubmenu {
  top: 0;
  left: 100%;
  z-index: 1002;
}
/* Position submenu in the sidebar relative to a wrapper */
.sidebar .menu-link .submenu-wrapper {
  position: relative;
  /* Make the wrapper relatively positioned */
}
.sidebar .menu-link .submenu-wrapper .sbsubmenu {
  position: absolute;
  left: 100%;
  top: -40px;
}
.sbsubmenu li a {
  color: #66D1FF;
}
.sbsubmenu li:hover {
  background-color: #66D1FF26;
}
`, "",{"version":3,"sources":["webpack://./src/components/MenuPane.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,0BAAA;EACA,wCAAA;EACA,+BAAA;EACA,aAAA;EACA,wBAAA;EACA,yBAAA;EACA,oCAAA;AACJ;AAEA;EACE,YAAA;AAAF;AAGA;EACE,WAAA;AADF;AAIA;EACE,YAAA;EACA,kBAAA;AAFF;AAKA;;EACE,eAAA;AAFF;AAKA;;EACE,qCAAA;AAFF;AAKA;EACE,kBAAA;AAHF;AAMA;EACE,cAAA;EACA,eAAA;AAJF;AAOA;EACE,2BAAA;EACA,kBAAA;AALF;AAQA;EACE,2BAAA;EACA,kBAAA;AANF;AASA;EACE,sBAAA;AAPF;AAUA;EAAoB,YAAA;AAPpB;AAQA;EAAwB,YAAA;EAAc,WAAA;AAJtC;AAMA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;AAJF;AAOA;EACE,mCAAA;AALF;AAQA;EAAe,YAAA;AALf;AAOA;EACE,iBAAA;AALF;AAQA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AANF;AAQA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;AANF;AASA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;AAPF;AAUA;EACE,cAAA;EACA,aAAA;EACA,qBAAA;AARF;AAWA;EACE,WAAA;AATF;AAYA;EACE,eAAA;AAVF;AAaA;EACE,aAAA;AAXF;AAcA;EACE,cAAA;AAZF;AAeA;EACE,YAAA;AAbF;AAgBA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAdF;AAiBA;EACE,2BAAA;EACA,kBAAA;AAfF;AAkBA;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;AAhBF;AAmBA;EACE,aAAA;AAjBF;AAoBA;EACE,2BAAA;EACA,kBAAA;AAlBF;AAqBA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;AAnBF;AAsBA;EACE,YAAA;EACA,WAAA;AApBF;AAuBA;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;AArBF;AAwBA;EACE,2BAAA;AAtBF;AAyBA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;AAvBF;AACA,oBAAoB;AA0BpB;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AAxBF;AA2BA;;EAEE,cAAA;AAzBF;AA4BA;EACE,MAAA;EACA,UAAA;EACA,aAAA;AA1BF;AACA,0DAA0D;AA6B1D;EACE,kBAAA;EA3BA,2CAA2C;AAC7C;AA6BA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;AA3BF;AA8BA;EACE,cAAA;AA5BF;AA+BA;EACE,2BAAA;AA7BF","sourcesContent":[".menu-pane {\n    position: absolute;\n    left: 0;\n    color: #fff;\n    top: 82px;\n    height: calc(100vh - 80px);\n    box-shadow: 5px 0 5px rgba(0, 0, 0, 0.3); \n    transition: transform 0.4s ease;  \n    z-index: 1000; \n    font-family: 'Open Sans';\n    display: block !important; \n    background-color: #3D434F !important; \n}\n\n.menu-pane .vertical-menu.open {\n  width: 320px;\n}\n\n.menu-pane .vertical-menu.closed {\n  width: 88px; \n}\n\n.close-menu {\n  float: right;\n  margin-right: 10px;\n}\n\n.close-menu:hover, .open-menu:hover {\n  cursor: pointer;\n}\n\n.close-menu img:hover, .open-menu img:hover {\n  filter: brightness(1.4) contrast(0.8);\n}\n\n.menu-link-wrapper {\n  padding-left: 20px;\n}\n\n.menu-link a {\n  color: #66D1FF;\n  font-size: 16px;\n}\n\n.menulink.active {\n  background-color: #66D1FF26;\n  border-radius: 4px;\n}\n\n.full-menu>.menu-link>a:hover {\n  background-color: #66D1FF26;\n  border-radius: 4px;\n}\n\n.menu-link {\n  vertical-align: middle;\n}\n\n.menu-link a>span { float: right; }\n.menu-link a>span img { height: 18px; width: 18px; }\n\n.menu-link img {\n  height: 22px;\n  width: 22px;\n  padding-right: 10px;\n  vertical-align: middle;\n}\n\n.menu-link a:hover img {\n  filter: brightness(1.2) contrast(1);\n}\n\n.sidebar img { padding: 0px; }\n\n.vertical-menu.open{\n  margin-left: 20px;\n}\n\n.vertical-menu ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.menu-divider {\n  height: 1px;\n  width: 300px;\n  background-color: #4D556F;\n  display: block;\n}\n\n.full-menu li {\n  width: 300px;\n  position: relative;\n  border-radius: 4px;\n}\n\n.full-menu a {\n  display: block;\n  padding: 10px;\n  text-decoration: none;\n}\n\n.vertical-menu h3 {\n  color: #ccc;\n}\n\n.menu-opener {\n  cursor: pointer;\n}\n\n.submenu {\n  display: none; \n}\n\n.submenu.active {\n  display: block;\n}\n\n.submenu li {\n  width: 290px;\n}\n\n.submenu li a {\n  margin-left: 20px;\n  color: #66D1FF;\n  font-size: 16px;\n}\n\n.submenu li:hover {\n  background-color: #66D1FF26;\n  border-radius: 4px;\n}\n\n.sidebar-wrapper {\n  width: 100%;\n  text-align: center;\n  padding-top: 22px;\n}\n\n.sidebar-wrapper div:hover svg path {\n  fill: #CAEEFF;\n}\n\n.sidebar li:hover {\n  background-color: #66D1FF26;\n  border-radius: 4px;\n}\n\n.sidebar li a {\n  display: flex;\n  height: 45px;\n  width: 45px;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  margin: auto;\n}\n\n.sidebar li a img {\n  height: 22px;\n  width: 22px;\n}\n\n.sidebar-divider {\n  height: 1px;\n  width: 100%;\n  background-color: #4D556F;\n  display: block;\n}\n\n.highlighted {\n  background-color: #66D1FF80;\n}\n\n.menu-footer {\n  position: absolute;\n  bottom: 0;\n  width: 290px;\n  text-align: center;\n  border-radius: 0 0 5px 5px;\n}\n\n/* Sidebar Submenu */\n.sbsubmenu {\n  display: none;\n  width: 200px;\n  white-space: nowrap;\n  position: absolute;\n  background-color: #3D434F;\n  border-radius: 5px;\n  z-index: 1001;\n}\n\n.sidebar .menu-link:hover .sbsubmenu, \n.vertical-menu.open .menu-link:hover .sbsubmenu {\n  display: block;\n}\n\n.vertical-menu.open .sbsubmenu {\n  top: 0;\n  left: 100%; \n  z-index: 1002;\n}\n\n/* Position submenu in the sidebar relative to a wrapper */\n.sidebar .menu-link .submenu-wrapper {\n  position: relative; /* Make the wrapper relatively positioned */\n}\n\n.sidebar .menu-link .submenu-wrapper .sbsubmenu {\n  position: absolute;\n  left: 100%;\n  top: -40px;\n}\n\n.sbsubmenu li a {\n  color: #66D1FF;\n}\n\n.sbsubmenu li:hover {\n  background-color: #66D1FF26;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
